import React from "react";
import { Box, Typography, Skeleton, Alert, List, ListItem, ListItemText, Button } from "@mui/material";

const AiInsights = ({ insights, isLoading, error, onGenerate }) => {
  if (isLoading) {
    return (
      <Box display="flex" flexDirection="column" gap={2}>
        <Skeleton variant="text" width="90%" height={28} />
        <Skeleton variant="rounded" width="100%" height={48} />
        <Skeleton variant="text" width="85%" height={28} />
        <Skeleton variant="rounded" width="100%" height={64} />
        <Skeleton variant="text" width="70%" height={28} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" flexDirection="column" gap={1}>
        <Alert severity="warning" variant="outlined">
          Não foi possível carregar os insights da IA no momento.
        </Alert>
        {onGenerate && (
          <Button
            variant="outlined"
            size="small"
            onClick={onGenerate}
          >
            Tentar novamente
          </Button>
        )}
      </Box>
    );
  }

  if (!insights) {
    return (
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography variant="body2" color="text.secondary">
          Os insights da IA serão carregados automaticamente ao abrir este painel.
        </Typography>
        {/* Nenhum botão aqui: carregamento é automático ao abrir o acordeão */}
      </Box>
    );
  }

  const {
    customerContext,
    requestContext,
    clientIntent,
    recommendedActions,
    toneSummary,
  } = insights;

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      {customerContext && (
        <Box>
          <Typography variant="subtitle2" fontWeight="bold">
            Contexto do cliente
          </Typography>
          <Typography variant="body2">{customerContext}</Typography>
        </Box>
      )}

      {requestContext && (
        <Box>
          <Typography variant="subtitle2" fontWeight="bold">
            Contexto da solicitação
          </Typography>
          <Typography variant="body2">{requestContext}</Typography>
        </Box>
      )}

      {clientIntent && (
        <Box>
          <Typography variant="subtitle2" fontWeight="bold">
            Intenção provável do cliente
          </Typography>
          <Typography variant="body2">{clientIntent}</Typography>
        </Box>
      )}

      {toneSummary && (
        <Box>
          <Typography variant="subtitle2" fontWeight="bold">
            Tom da conversa
          </Typography>
          <Typography variant="body2">{toneSummary}</Typography>
        </Box>
      )}

      {Array.isArray(recommendedActions) && recommendedActions.length > 0 && (
        <Box>
          <Typography variant="subtitle2" fontWeight="bold">
            Próximos passos sugeridos
          </Typography>
          <List dense>
            {recommendedActions.map((action, index) => (
              <ListItem key={index} sx={{ py: 0.25 }}>
                <ListItemText
                  primaryTypographyProps={{ variant: "body2" }}
                  primary={action}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};

export default AiInsights;

